module.exports = __webpack_public_path__ + "static/media/logo_cn_nl.0ace0b34.svg";